import { render, staticRenderFns } from "./chooseminofficial.vue?vue&type=template&id=328f209d&scoped=true"
import script from "./chooseminofficial.vue?vue&type=script&lang=js"
export * from "./chooseminofficial.vue?vue&type=script&lang=js"
import style0 from "./chooseminofficial.vue?vue&type=style&index=0&id=328f209d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328f209d",
  null
  
)

export default component.exports